export default "__VITE_PUBLIC_ASSET__5e1b4716__"